import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog-cutomizado',
  templateUrl: './message-dialog-cutomizado.component.html',
  styleUrls: ['./message-dialog-cutomizado.component.css']
})
export class MessageDialogCutomizadoComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { message: string }) { }
}
